<template>
    <paper>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :searchTotalTitle="config.searchTotalTitle"
            :loading="loading"
            :pickerConfig="config.pickerConfig"
            :currentPage="searchParams.pageNo"
            searchId="performance-vehicleTransitWarningQuery"
            pageID="performance-vehicleTransitWarning"
            @search-list-change="searchListChange"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @viewTrack-btn="viewTrack"
        >
            <span slot="search-list-advance-right">
                <el-button @click="handleReset" type="primary" class="reset-btn">重 置</el-button>
            </span>
            <div slot="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="OTP_VEHICLE_TRANSIT_WARN_REPORT"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'otp04200001'" class="mgl-10">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
        </m-pane>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/otpPanel';
import config from './config.js';
import { queryByPage, queryCount } from '../../../api/vehicleTransitWarning';
import reportExport from '@/components/lots/reportExportPlugin';
import { formatSearchData, validateSearchData } from './util.js';
import { dictWithUrl } from '@/components/lots/api.js';
import { mapState } from 'vuex';
export default {
    name: 'vehicleTransitWarning',
    components: {
        paper,
        mPane,
        reportExport
    },
    data () {
        return {
            config,
            loading: false,
            dictData: {}, // 数据字典集合
            totalData: [],
            pageTotal: 0,
            currentPage: 0,
            searchParams: {
                pageNo: 1,
                pageSize: 10,
                param: {}
            }
        };
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier,
            currentTenant: state => state.currentTenant
        })
    },
    mounted () {
        this.getDicData();
    },
    methods: {
        /**
         * @description 获取数据字典
         * @param {string} 数据字典编码字符串
         * @return {Object} 数据字典集合
         * 整车在途预警-预警提示: OTP_WARNING_PROMPT
         */
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'OTP_WARNING_PROMPT,OTP_NETWORK_ACCESS_STATUS,OTP_TRACKING_SOURCE,TMS_SHIPPING_TYPE,SYS_PROFESSIONAL_COMPANY'
            );
            this.dictData = dict.data;
        },
        searchListChange (config, data) {
            if (config.value === 'companyName') {
                this.$nextTick(() => {
                    this.$refs.tablePage.$refs.searchList.searchData.siteName = null;
                    this.$refs.tablePage.$refs.searchList.searchData.siteCode = null;
                });
            }
        },
        selectChange () { },
        /**
         * @description 初始化查询
         */
        initSearch () {
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        /**
         * @description 查询
         * @param {*} data
         */
        searchChange (data) {
            // 格式化查询参数
            const searchData = formatSearchData(data);
            // 查询条件校验
            const isQueryOk = validateSearchData(searchData);
            if (!isQueryOk) return;
            this.searchParams = this.getSearchData(searchData);
            this.getList();
            this.getListPageCount();
        },
        // 组装查询参数
        getSearchData (data) {
            const _searchData = {
                ...this.searchParams,
                pageNo: 1,
                param: {
                    ...data,
                    carrierCode: this.supplier.supplierCode,
                }
            };
            for (const key in _searchData.param) {
                if (_searchData.param[key] === '') delete _searchData.param[key];
            }
            return _searchData;
        },
        // 获取列表数据
        getList () {
            this.loading = true;
            queryByPage(this.searchParams).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list || [];
                    this.totalData.forEach(item => {
                        item.warningPrompt = this.handleWarningPrompt(item.isNet);
                        item.isNet = this.dictData.OTP_NETWORK_ACCESS_STATUS[item.isNet] || '';
                        item.lastTrackingSource = this.dictData.OTP_TRACKING_SOURCE[item.lastTrackingSource] || '';
                        item.shippingType = this.dictData.TMS_SHIPPING_TYPE[item.shippingType] || '';
                    });
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        // 获取预警提示
        handleWarningPrompt(isNet) {
            let type;
            if (isNet === 0) {
                type = '02';
            } else if (isNet === 1) {
                type = '01';
            } else if (isNet === 2) {
                type = '03';
            } else {
                type = '04';
            }
            return this.dictData.OTP_WARNING_PROMPT[type];
        },
        // 获取列表数据条数
        getListPageCount () {
            queryCount(this.searchParams.param).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getList();
        },
        /*
         * @description 导出
        */
        exportFile (submit) {
            const exportParams = {
                ...this.searchParams.param,
                tenantCode: this.currentTenant.tenantCode
            };
            submit(exportParams);
        },
        // 查看轨迹
        viewTrack (row) {
            this.$router.push({
                path: '/otp/distribute/waybill-map-monitor',
                query: {
                    dispatchNo: row.dispatchNo
                }
            });
        },
        // 重置查询参数
        handleReset () {
            this.$refs.tablePage.$refs.searchList.dataInit(null, true);
        }
    }
};
</script>

<style scoped>
.reset-btn {
    margin-left: 10px;
}
</style>
